import { ACCOUNTING_ACCOUNTS_ACTION_TYPE } from '../actions';

const initialState = null;

const accountsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACCOUNTING_ACCOUNTS_ACTION_TYPE.GET_ACCOUNTS:
      return payload || state;

    default:
      return state;
  }
};

export default accountsReducer;
